<template>
  <div class="notice min-height">
    <div class="padding">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="notice-item flex align-center justify-between padding-sm"
        @click="toDetail(item.id)"
      >
        <div class="left-text">
          <h3 class="ovHide">{{ item.title }}</h3>
          <p class="ovHide2">
            {{ item.content }}
          </p>
          <p class="margin-top-xs" style="color: #999">
            {{ item.create_time }}
          </p>
        </div>
        <div class="right-btn" v-if="item.notice_type === 1">
          <el-button type="primary" v-if="item.is_read === 0">未读</el-button>
          <el-button type="info" v-else>已读</el-button>
        </div>
        <div class="right-btn" v-if="item.notice_type === 2">
          <el-button type="primary" v-if="item.is_read === 0">未读</el-button>
          <el-button type="info" v-else>已读</el-button>
          <el-button type="primary" v-if="item.is_reply === 0"
            >未反馈</el-button
          >
          <el-button type="info" v-else>已反馈</el-button>
        </div>
        <div class="right-btn" v-if="item.notice_type === 3">
          <el-button type="primary" v-if="item.is_read === 0">未读</el-button>
          <el-button type="info" v-else>已读</el-button>
          <el-button type="primary" v-if="item.is_signUp === 0"
            >未报名</el-button
          >
          <el-button type="info" v-else>已报名</el-button>
        </div>
      </div>
      <el-pagination
        v-if="list.length > 0"
        class="page-all"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>


      <el-empty description="暂无数据" v-if="list.length === 0"></el-empty>
    </div>
  </div>
</template>

<script>
import { noticeList } from '@/api/member'
export default {
  name: "notice",
  data () {
    return {
      page: 1,
      limit: 10,
      total: 0,
      list: [],

    }
  },
  created () {
    this.$emit("setIndex", this.$route.path, "通知公告  / ", false, 'icon-gonggao');
    this.getList()
  },
  components: {},
  methods: {
    //  去通知公告详情
    toDetail (id) {
      this.$router.push('/home/noticeDetail/' + id)
    },
    //  获取列表
    async getList () {
      let _list = await noticeList(this.page, this.limit)
      this.list = _list.data.data
      this.total = _list.data.total
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.notice {
  .notice-item {
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    &:hover {
      background: rgba($color: #ccc, $alpha: 0.2);
    }
    .left-text {
      width: 70%;
      h3 {
        margin-bottom: 15px;
      }
    }
    .right-btn {
      .el-button {
        display: block;
        width: 100px;
        margin: 0 0 10px 0;
      }
    }
  }
}
</style>